import {isLoggedIn} from 'utils/auth'

export default (store) => ({
  path: 'upload-logs',
  onEnter: isLoggedIn(store),
  getComponent(nextState, callback) {
    require.ensure([], (require) => {
      const component = require('./UploadLogs').default
      callback(null, component)
    }, 'UploadLogs')
  }
})



// WEBPACK FOOTER //
// ./src/routes/rule-ui-routes/UploadLogs/index.js